import { ASC, COLORS } from '@btime/constants'
import React from 'react'

import Icon from './Icon'

const SortIndicator = ({ active, type }) => {
  if (!active) return false
  const name = type === ASC ? 'BsFillCaretUpFill' : 'BsFillCaretDownFill'
  return <Icon name={name} size=".7rem" color={COLORS.dark3} />
}

export default SortIndicator
